<template>
  <div :class="$style.container" class="add">
    <template v-if="isShowLoading">
        <loading></loading>
    </template>
    <h4>添加银行卡</h4>
    <div :class="$style.content">
      <Form :model="form" :label-width="80" :rules="ruleValidate">
        <FormItem label="开户姓名" style="width: 280px;" prop="name">
          <Input v-model="form.name" placeholder="" />
        </FormItem>
        <FormItem label="证件号码" style="width: 280px;" prop="idCardNo">
          <Input v-model="form.idCardNo" placeholder="" />
        </FormItem>
        <FormItem label="银行卡号" style="width: 330px;" prop="bankNo">
          <Row>
            <Col span="19">
            <Input v-model="form.bankNo" placeholder="" />
            </Col>
            <Col span="4" style="margin-left:10px;">
            <Button type="text" style="color: #4E81F0;" @click.stop="handleShowModalClick">支持银行</Button>
            </Col>
          </Row>
        </FormItem>

        <FormItem label="手机号码" style="width: 446px;" prop="phoneNo">
          <Row>
            <Col span="13" style="min-width:100px;margin-right:12px;">
            <Input v-model="form.phoneNo" placeholder="" />
            </Col>
            <Col span="9">
            <Button type="text">请填写此卡在银行预留的手机号码，验证此银行卡是否真实属于您本人</Button>
            </Col>
          </Row>
        </FormItem>

        <FormItem style="width: 450px;">
          <router-link to="#">
            <Button type="text" v-if="false">《环球汇通支付相关协议》</Button>
          </router-link>
        </FormItem>
        <FormItem style="width: 450px;margin-left:10px;">
          <Button type="primary" @click.stop="handleAgreeClick" >同意协议并确定</Button>
        </FormItem>
      </Form>
      <Modal v-model="showModal" title="支持的银行卡列表" :footer-hide="true" class="add_Card_modal">
        <ul>
          <li v-for="(item,idx) in bankLists" :key="item.name+idx" @click.stop="handleClickItem(idx)" :class="activeNum === idx ? 'active' : ''">{{item.name}}</li>
        </ul>
        <footer>
          <Button type="primary" style="margin-bottom:10px;" @click.stop="handleCloseClick">关闭</Button>
        </footer>
      </Modal>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowLoading: false,
      showModal: false,
      activeNum: null,
      timer: null,
      form: {
        name: '',
        idCardNo: "",
        bankNo: "",
        bankName: "",
        phoneNo: "",
        msgNo: ""
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请填写开户姓名",
            trigger: "blur"
          }
        ],
        idCardNo: [
          {
            required: true,
            message: "请填写证件号码",
            trigger: "blur"
          }
        ],
        bankNo: [
          {
            required: true,
            message: "请填写银行卡号",
            trigger: "blur"
          }
        ],
        bankName: [
          {
            required: true,
            message: "请填写开户行",
            trigger: "blur"
          }
        ],
        phoneNo: [
          {
            required: true,
            message: "请填写手机号码",
            trigger: "blur"
          }
        ],
        msgNo: [
          {
            required: true,
            message: "请填写短信验证码",
            trigger: "blur"
          }
        ]
      },
      bankLists: [],
      btn_text: "获取验证码",
      userId: ''
    };
  },
  created () {
    this.userId = sessionStorage.getItem('userName')
    this.getBankList()
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取银行列表
    async getBankList () {
      try {
        let res = await this.$api.get(`${this.lee}/ec/bindBank/v1/getAllBankList`)
        if (res.code === 200) {
          this.bankLists = res.data
        }
      } catch(err) {
        console.log(err)
      }
    },
    // 打开模态框
    handleShowModalClick() {
      this.showModal = true;
    },
    // 取消模态框
    handleCloseClick() {
      this.showModal = false;
    },
    // 选中item
    handleClickItem(idx) {
      this.activeNum = idx;
    },
    // 绑定银行卡
    async handleAgreeClick() {
      this.isShowLoading = true
      try {
        let params = {
          url: window.location.hostname
        };
        let bodyPatams = {
          userid: this.userId,
          accNo: this.form.bankNo,
          phoneNo: this.form.phoneNo,
          idnumber: this.form.idCardNo,
          idname: this.form.name, 
          orderChannel: 'PC',
          bindUrl: encodeURIComponent(
            `${window.location.origin}/#/my-personalUser/myBankCard`
          )
        };
        let res = await this.$api.post(
          `${this.lee}/ec/bindBank/v1/wxBindBank`,
          params,
          bodyPatams
        );
        if (res.code === 200) {
          window.location.href = res.data
        }
        this.isShowLoading = false
      } catch (err) {
        this.isShowLoading = false
      }
    }
  }
};
</script> 
<style lang="less" module>
.container {
  padding: 30px 20px;
  h4 {
    font-size: 16px;
    font-weight: bold;
    color: #191919;
    margin-top: 20px;
  }
  .content {
    margin-top: 50px;
  }
}
</style>

<style scoped>
.add >>> .ivu-btn-text:focus {
  box-shadow: 0 0 0 0px rgba(45, 140, 240, 0.2);
}
</style>

<style lang="less">
.add_Card_modal {
  ul {
    &:after {
      display: block;
      content: " ";
      overflow: hidden;
      clear: both;
    }
    li {
      margin: 5px 10px;
      padding: 5px;
      float: left;
      cursor: pointer;
    }
    .active {
      background: #eee;
      color: #000;
    }
  }
  footer {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #fff;
  }
}
</style>
